import React from 'react';

import { Alert } from '@mui/material';

import type { AlertProperties } from './AlertContainer.types';

export const AlertMessage: React.FC<AlertProperties> = ({
  children,
  severity,
}) => {
  return (
    <Alert
      severity={severity}
      variant='outlined'
      sx={{ backgroundColor: 'background.default' }}
    >
      {children}
    </Alert>
  );
};
